
<style scoped>
    .p-t {
        margin-bottom: 0px !important;
    }
</style>
<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
      >
        <!-- <v-chip
          color="orange"
          outlined
          small
        >
          调
        </v-chip> -->
        <v-btn
          x-small
          outlined
          fab
          dark
          max-width="18"
          max-height="18"
          color="orange"
        >
          调
        </v-btn>

      </span>
    </template>
    <div sytle="z-index:10">
      <p class="p-t">
        系统计算：{{ item.sys_value }} {{ unit }}
      </p>
      <h4>HR调整</h4>
      <p class="p-t">
        调整后：{{ item.adjust_value }} {{ unit }}
      </p>
      <p class="p-t">
        调整原因：{{ item.reason }}
      </p>
    </div>
  </v-tooltip>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => ({})
      },
      unit: {
        type: String,
        default: () => '天'
      }

    }
  }
</script>
